var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appendix-top"},[_c('div',{ref:"titleSection",staticClass:"anim-wrapper"},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"appendix-title"},[_c('span',{staticClass:"line"},[_vm._v("Appendix")])])
}]

export { render, staticRenderFns }